import React from 'react';

const PanggungCreativa = () => {
    return (
        <div className="container mx-auto px-4 py-12">
            <h1 className="text-3xl font-bold text-[#1E3A8A] mb-8">Pinjam Panggung Creativa</h1>
            <div className="card-glass">
                <h2 className="text-xl font-bold text-[#0D9488] mb-4">Fasilitas Panggung Creativa</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <h3 className="font-semibold text-[#1E3A8A] mb-2">Spesifikasi Panggung</h3>
                        <ul className="list-disc list-inside space-y-1 text-gray-600">
                            <li>Ukuran: 8x6 meter</li>
                            <li>Kapasitas: 50 orang</li>
                            <li>Sound System lengkap</li>
                            <li>Lighting panggung</li>
                            <li>Backdrop LED</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="font-semibold text-[#1E3A8A] mb-2">Ketentuan Peminjaman</h3>
                        <ol className="list-decimal list-inside space-y-1 text-gray-600">
                            <li>Mengisi form peminjaman</li>
                            <li>Melampirkan proposal kegiatan</li>
                            <li>Mematuhi tata tertib</li>
                            <li>Menjaga kebersihan</li>
                            <li>Mengembalikan sesuai jadwal</li>
                        </ol>
                    </div>
                </div>
                <div className="mt-6 p-4 bg-yellow-50 rounded-lg">
                    <p className="text-yellow-800">
                        ⚠️ Peminjaman minimal H-7 sebelum acara dan konfirmasi ketersediaan jadwal.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PanggungCreativa;